import type {
  CommonAddress,
  AddressLocation,
  StreetAddress,
} from '@wix/ambassador-wix-atlas-service-web/types';
import type {
  DurationRange,
  FulfillmentDetails,
} from '@wix/ambassador-restaurants-operations-v1-operation/types';
import type { AdditionalInfoLabel } from '@wix/ambassador-restaurants-v1-fulfillment-method/types';

export type { SchedulingType } from '@wix/ambassador-restaurants-operations-v1-operation/types';

export type Money = {
  amount: number;
  currency: string;
};

export enum DispatchType {
  PICKUP = 'PICKUP',
  DELIVERY = 'DELIVERY',
  DINE_IN = 'DINE_IN',
}

export type Address = CommonAddress;

export type AddressInputAddress = {
  formatted: string;
  addressLine?: string;
  location?: AddressLocation;
  streetAddress?: StreetAddress;
  city?: string;
  subdivision?: string;
  country?: string;
  postalCode?: string;
  subdivisions?: string[];
};

export type OSLocation = {
  name: string;
  address?: Address;
  default?: boolean;
  timeZone?: string;
};

export type DispatchLocation = OSLocation & {
  _id: string;
  acceptOrders: boolean;
  operationId: string;
};

export type TimeSlot = {
  id: string;
  startTime: string;
  endTime: string;
  dispatchType: DispatchType;
  startsNow?: boolean;
  fulfillmentDetails: FulfillmentDetails;
};

export type DispatchInfo = {
  address?: Address;
  selectedTimeSlot?: TimeSlot;
  isAvailable?: boolean;
  maxTimeOptions?: number;
  durationRangeOptions?: DurationRange;
  minOrder?: string;
  deliveryFee?: string;
  freeFulfillmentPriceThreshold?: string;
  minDate?: string;
  dineInInstructions?: string;
  dineInAdditionalLabel?: AdditionalInfoLabel;
  dineInCustomInfo?: string;
  dineInCustomerResponse?: string;
  dineInResolvedLabel?: string;
};

export type DispatchesInfo = Record<DispatchType, DispatchInfo>;

export type DispatchState = {
  selectedDispatchType: DispatchType;
  dispatchesInfo: DispatchesInfo;
  configuredDispatchTypes: DispatchType[];
  availableDispatchTypes: DispatchType[];
};

export type DispatchStateByLocation = Record<string, DispatchState>;
